/**
 * @generated SignedSource<<4049d631d59296f8d7909feb548be4a6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$data = {
  readonly fieldOption: {
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView";
};
export type singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$key = {
  readonly " $data"?: singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singleSelect_issueFieldSingleSelectReadviewFull_SingleSelectReadView",
  "selections": [
    {
      "concreteType": "JiraOption",
      "kind": "LinkedField",
      "name": "fieldOption",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "type": "JiraSingleSelectField"
};

(node as any).hash = "6c27b0c3f4b268dcf2e659dd33a134c7";

export default node;
